import script from "./PasswordLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordLogin.vue?vue&type=script&setup=true&lang=js"

import "./PasswordLogin.vue?vue&type=style&index=0&id=d5245718&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5245718"]])

export default __exports__